






import { defineComponent, PropType } from "@vue/composition-api";
import { Location } from "vue-router";

export default defineComponent({
  name: "LandingCreatorsButton",
  props: {
    to: { type: Object as PropType<Location> },
  },
});
